import React from "react";
import { Button } from "react-bootstrap";
import HeaderLayout from "./HeaderLayout";
import CardsLayout from "./cardsLayout";
import { Link } from "react-router-dom";
import { getSystemTrackingByPoAndDC } from "../../../actions";
import Spinner from "../../common/Spinner";
import Sanckbar from "../../common/Sanckbar";

class ViewDiYardManagementeSystemTracking extends React.Component {
  state = {
    notificationMsg: "",
    isSaveEnabled: false
  };
  constructor() {
    super();
    this.cardsData = [];
    this.allData = {};
    this.oldInfo = [];
    this.newInfo = {};
  }
  componentDidMount() {
    document.addEventListener("keydown", this.pressEnter);
  }
  setErrorMessage = msg => {
    this.setNotification(msg, "red", "cancel");
  };
  setWarningMessage = msg => {
    this.setNotification(msg, "orange", "warning", 3000);
  };
  setSuccessMessage = msg => {
    this.setNotification(msg, "#47fb47", "check", 3000);
  };
  setTransitioMessage = msg => {
    this.setNotification(msg, null, null);
  };
  setNotification = (text, color, icon, timeout) => {
    clearTimeout(this.snackbarTimer);

    if (text) {
      this.setState({ notificationMsg: { text, color, icon } });
      this.setState({ isNotificationOpened: true });
    } else {
      this.setState({ isNotificationOpened: false });
    }
    if (timeout) {
      this.snackbarTimer = setTimeout(() => {
        this.setState({ isNotificationOpened: false });
      }, timeout);
    }
  };
  lookup = msg => {
    this.setTransitioMessage(<Spinner msg="Loading..." />);
    if (
      this.state.lookup &&
      this.state.lookup.poNumber &&
      this.state.lookup.suffix
    ) {
      var poNumber = this.state.lookup.poNumber;
      var suffix = this.state.lookup.suffix;
      getSystemTrackingByPoAndDC(poNumber, suffix).then(res => {
        msg ? this.setSuccessMessage(msg) : this.setTransitioMessage("");
        var data = [];

        if (res.data.success) {
          data = res.data.data;
        } else {
          data = false;
          this.setErrorMessage("Nothing found.");
        }
        this.setState({ data });
        this.setState({
          header: [
            {
              label: "PO Number",
              name: "poNumber",
              value: data === false ? " " : data.poNumber
            },
            {
              label: "Suffix",
              name: "suffix",
              value: data === false ? " " : data.suffix
            },
            {
              label: "Status",
              name: "status",
              value: data === false ? " " : data.status
            },
            {
              label: "Origin",
              name: "origin",
              value: data === false ? " " : data.origin
            },
            {
              label: "History",
              name: "history",
              value: data === false ? " " : data.history
            },
            {
              label: "Class",
              name: "clase",
              value: data === false ? " " : data.clase
            },
            {
              label: "Trans",
              name: "trans",
              value: data === false ? " " : data.trans
            },
            {
              label: "CRS Dock",
              name: "crsdock",
              value: data === false ? " " : data.crsdock
            },
            {
              label: "Inco Trms",
              name: "incoTerms",
              value: data === false ? " " : data.incoTerms
            },
            {
              label: "Vendor",
              name: "vend",
              value: data === false ? " " : data.vend
            },
            {
              label: "Vendor Name",
              name: "vendorName",
              value: data === false ? " " : data.vendorName
            },
            {
              label: "Agent",
              name: "agent",
              value: data === false ? " " : data.agent
            },
            {
              label: "PO Note",
              name: "poNote",
              value: data === false ? " " : data.poNote
            }
          ],
          cards: [
            {
              Card1: [
                {
                  label: "Navis Ref ID",
                  name: "navisRefID",
                  value: data === false ? " " : data.navisRefID
                },
                {
                  label: "Customer Ref ID",
                  name: "customerRefID",
                  value: data === false ? " " : data.customerRefID
                },
                {
                  label: "Final Seal #",
                  name: "finalSeal",
                  value: data === false ? " " : data.finalSeal
                },
                {
                  label: "Navis Date",
                  name: "navisDate",
                  value: data === false ? " " : data.navisDate
                },
                {
                  label: "Destination",
                  name: "destination",
                  value: data === false ? " " : data.destination
                },
                {
                  label: "Container/Tracking #",
                  name: "containerTrk",
                  value: data === false ? " " : data.containerTrk
                },
                {
                  label: "Load Port",
                  name: "loadPort",
                  value: data === false ? " " : data.loadPort
                },
                {
                  label: "Discharge Port",
                  name: "dischargePort",
                  value: data === false ? " " : data.dischargePort
                },
                {
                  label: "Size",
                  name: "containerSize",
                  value: data === false ? " " : data.containerSize
                },
                {
                  label: "Vessel/Carrier",
                  name: "vesselCarrier",
                  value: data === false ? " " : data.vesselCarrier
                },
                {
                  label: "US Carrier",
                  name: "usCarrier",
                  value: data === false ? " " : data.usCarrier
                },
                {
                  label: "Stacking",
                  name: "stacking",
                  value: data === false ? " " : data.stacking
                },
                {
                  label: "ASN Qty Order",
                  name: "asnQtyOrdered",
                  value: data === false ? " " : data.asnQtyOrdered
                },
                {
                  label: "ASN Qty Shipped",
                  name: "asnQtyShipped",
                  value: data === false ? " " : data.asnQtyShipped
                },
                {
                  label: "Container Load",
                  name: "containerLoad",
                  value: data === false ? " " : data.containerLoad
                },
                {
                  label: "Country of Origin",
                  name: "countryOrg",
                  value: data === false ? " " : data.countryOrg
                },
                {
                  label: "Appoint D/T",
                  name: "appointDT",
                  value: data === false ? " " : data.appointDT
                },
                {
                  label: "Total Cases",
                  name: "totalCases",
                  value: data === false ? " " : data.totalCases
                },
                {
                  label: "Origin Seal #",
                  name: "orgSeal",
                  value: data === false ? " " : data.orgSeal
                },
                {
                  label: "Action DT",
                  name: "actionDT",
                  value: data === false ? " " : data.actionDT
                },
                {
                  label: "Other Info",
                  name: "otherInfo",
                  value: data === false ? " " : data.otherInfo
                }
              ]
            },
            {
              "Status Dates": [
                {
                  label: "Factory Ship",
                  name: "factoryShipAct",
                  value: data === false ? " " : data.factoryShipAct
                },
                {
                  label: "US Customs",
                  name: "usCustomsAct",
                  value: data === false ? " " : data.usCustomsAct
                },
                {
                  label: "CFS Arrival",
                  name: "cfsArrivalAct",
                  value: data === false ? " " : data.cfsArrivalAct
                },
                {
                  label: "DC Arrival",
                  name: "dcArrivalAct",
                  value: data === false ? " " : data.dcArrivalAct
                },
                {
                  label: "Export Load",
                  name: "exportLoadAct",
                  value: data === false ? " " : data.exportLoadAct
                },
                {
                  label: "Gate in D/T",
                  name: "gateInDT",
                  value: data === false ? " " : data.gateInDT
                },
                {
                  label: "Export Ship",
                  name: "exportShipAct",
                  value: data === false ? " " : data.exportShipAct
                },
                {
                  label: "Gate Out D/T",
                  name: "gateOutDT",
                  value: data === false ? " " : data.gateOutDT
                },
                {
                  label: "US Arrival",
                  name: "usArrivalAct",
                  value: data === false ? " " : data.usArrivalAct
                },
                {
                  label: "CU Rel Date",
                  name: "cuRelDate",
                  value: data === false ? " " : data.cuRelDate
                }
              ]
            }
          ]
        });
      }).catch(err => {
        const code = String(err).split('code')[1];
        if(code == 401) {
          this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
        } else {
            this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
            setTimeout(() => {
              this.setErrorMessage();
            }, 3000);
        }
      });
    } else {
      this.setErrorMessage("Please type a PO Number and a suffix");
    }
  };
  getHeaderInfo = value => {
    this.setState({
      lookup: {
        poNumber: value.header.poNumber,
        suffix: value.header.suffix
      }
    });

    this.handleInformation(value);
  };
  getCardsInfo = value => {
    this.handleInformation(value);
  };
  handleInformation = value => {
    Object.keys(value[Object.keys(value)]).map(
      val => (this.allData[val] = value[Object.keys(value)][val])
    );
    if (this.state.data) {
      for (let i = 0; i < Object.keys(this.state.data).length; i++) {
        this.newInfo[Object.keys(this.state.data)[i]] = this.allData[
          Object.keys(this.state.data)[i]
        ]
          ? this.allData[Object.keys(this.state.data)[i]]
          : this.state.data[Object.keys(this.state.data)[i]];
      }
      this.checkHotChanges();
    }
  };
  checkHotChanges = () => {
    this.setState({
      isSaveEnabled:
        JSON.stringify(this.state.data).replace(/"/g, "") !==
        JSON.stringify(this.newInfo).replace(/"/g, "")
    });
  };
  pressEnter = e => {
    if (e.key === "Enter") {
      this.lookup();
    }
  };

  numberToZeroPadded = (num, z) => {
    var no = parseInt(num, 10);
    num = no.toString();
    var zeroNo = z - num.length;
    var zeros = "";
    for (let i = 0; i < zeroNo; i++) {
      zeros = "0" + zeros;
    }
    return zeros + no;
  };

  componentWillUnmount() {
    document.removeEventListener("keydown", this.pressEnter);
  }

  render() {
    return (
      <div className="container-fluid" id="example">
        <h3 className="page-title" style={{ textAlign: "center" }}>
          DI Yard Management System Tracking Information
        </h3>
        <HeaderLayout
          setHeaderInfo={this.getHeaderInfo}
          setErrorMessage={this.setErrorMessage}
          setSuccessMessage={this.setSuccessMessage}
          lookup={this.lookup}
          headerData={this.state.header}
        />
        <CardsLayout
          cardsData={this.state.cards}
          setCardsInfo={this.getCardsInfo}
          checkOrderConstraints={this.checkOrderConstraints}
        />

        <div className="button-bar">
          <div className="paginator" style={{ display: "flex" }} />
          <div className="buttons">
            <Link to="/" className="sub-menu-item-tag">
              <Button bsStyle="warning" className="btn-sm" disabled={false}>
                Close
              </Button>
            </Link>
          </div>
        </div>
        <Sanckbar
          mounted={this.state.isNotificationOpened}
          msg={{
            text: this.state.notificationMsg.text,
            color: this.state.notificationMsg.color,
            icon: this.state.notificationMsg.icon
          }}
          close={this.setNotification}
        />
      </div>
    );
  }
}
export default ViewDiYardManagementeSystemTracking;
